import { LayoutEnum } from '@app/common';
import React from 'react';
import { observer } from 'mobx-react-lite';
import { cn } from '../../../utils/tailwind';

interface MenuPropsInterface {
    children: Array<JSX.Element>;
    layout?: LayoutEnum;
}

export const Menu: React.FC<MenuPropsInterface> = observer(({ layout = LayoutEnum.Horizontal, children }) => {
    return (
        <nav
            className={cn(
                'm-0 flex p-0',
                layout === LayoutEnum.Vertical ? 'flex-col vl:flex-row vl:items-center' : 'flex-col',
            )}
        >
            {children.map((child, index) => {
                return React.cloneElement(child, {
                    layout,
                    key: index,
                });
            })}
        </nav>
    );
});
